import React from 'react';

const Arrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="7.94"
    height="15.698"
    viewBox="0 0 7.94 15.698"
  >
    <g id="down-arrow-1" transform="translate(0 15.698) rotate(-90)">
      <g id="Group_17" data-name="Group 17" transform="translate(0 0)">
        <path
          id="Path_9"
          data-name="Path 9"
          d="M15.519.18a.613.613,0,0,0-.867,0L8.283,6.535a.614.614,0,0,1-.868,0L1.046.179a.613.613,0,0,0-.866.868L6.548,7.4a1.842,1.842,0,0,0,2.6,0l6.369-6.356A.613.613,0,0,0,15.519.18Z"
          transform="translate(0 0)"
          //   fill="#4a4a4a"
        />
      </g>
    </g>
  </svg>
);

export default Arrow;
